import M from 'moment';
import LinkTitleComponent from '72cms-ui/components/table-elements/LinkTitleComponent';
import DateTimeComponent from '72cms-ui/components/table-elements/DateTimeComponent';
import CustomFilterComponent from '72cms-ui/components/helpers/CustomFilterComponent';
import RangeFilterComponent from '72cms-ui/components/helpers/RangeFilterComponent';
import ActiveSwitchActionComponent from '72cms-ui/components/table-elements/ActiveSwitchActionComponent';

export default {
    fields: {
        name: {
            label: 'Name',
            component: LinkTitleComponent,
            handler: (value, data) => {
                return value ? value : '(unknown)';
            }
        },
        email: {
            component: {
                template: `<a class="primary" :href="'#/subscriber/' + data.id">{{ initialValue }}</a>`,
                props: ['initialValue', 'data'],
            },
        },
        email_verified: {
            label: 'Verified',
            component: {
                template: `<span>{{ initialValue ? 'Yes' : 'No' }}</span>`,
                props: ['initialValue'],
            }
        },
        created_at: {
            label: 'Date',
            component: DateTimeComponent,
            dateFormat: 'DD MMM YYYY',
            timeFormat: 'hh:mm:ss',
        },
    },
	toolbar: ['create'],
    sortable: ['id', 'name', 'email', 'created_at'],
    filterable: [
        'email_verified',
    ],
    toolbar: ['export'],
    pagination: true,
    searchable: true,
    hierarchy: false,
    batchActions: ['active', 'delete'],
    actions: [
        {
            name: 'edit',
            component: 'edit-button',
            primary: true,
        },
        {
            name: 'active',
            component: ActiveSwitchActionComponent,
            primary: true,
        },
        {
            name: 'delete',
            component: 'delete-button',
            primary: true,
        },
    ],
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/collection.subscribers.js